import React from 'react';
import { Helmet } from 'react-helmet-async';

const ListMetaTags = ({ list, user }) => {
  if (!list) return null;

  const listUrl = `https://ynskje.no/list/${list.id}`;
  const listTitle = `${list.name} - Ynskje`;
  const wishCount = list.wishCount || 0;
  const memberCount = list.members?.length || 1;
  const isGroupList = list.isGroup;
  
  let listDescription = list.description || '';
  if (!listDescription) {
    if (isGroupList) {
      listDescription = `En delt felles ønskeliste med ${memberCount} ${memberCount > 1 ? 'medlemmer' : 'medlem'} og ${wishCount} ${wishCount === 1 ? 'ønske' : 'ønsker'}. Bli med og bidra til denne gavelisten!`;
    } else {
      listDescription = `En personlig ønskeliste med ${wishCount} ${wishCount === 1 ? 'ønske' : 'ønsker'}. Se listen og hjelp til å oppfylle ønsker!`;
    }
  }

  return (
    <Helmet>
      <title>{listTitle}</title>
      <meta name="description" content={listDescription} />
      <meta name="robots" content="noindex, nofollow" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={listUrl} />
      <meta property="og:title" content={listTitle} />
      <meta property="og:description" content={listDescription} />
      <meta property="og:image" content="https://ynskje.no/ynskje%20large%20logo.png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Ynskje" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={listUrl} />
      <meta property="twitter:title" content={listTitle} />
      <meta property="twitter:description" content={listDescription} />
      <meta property="twitter:image" content="https://ynskje.no/ynskje%20large%20logo.png" />
    </Helmet>
  );
};

export default ListMetaTags;
